import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import axios from 'axios'
import config from 'config'

import useSnackbar from '../Snackbar/useSnackbar'

const useLogistics = () => {
  const { t } = useTranslation()
  const { showSnackbarMessage } = useSnackbar()

  const [state, setState] = useState({
    cars: [],
    isUpdating: false,
    error: null,
  })

  const setStartUpdating = useCallback(() => {
    setState((s) => ({
      ...s,
      isUpdating: true,
    }))
  }, [setState])

  const setStopUpdating = useCallback(
    (data) => {
      setState((s) => ({
        ...s,
        isUpdating: false,
        ...data,
        error: data?.error || null,
      }))
    },
    [setState]
  )

  const updateCheckCars = useCallback(
    async (items, callback) => {
      setStartUpdating()

      try {
        const result = await axios.post(`${config.apiBaseUrl}logistics/cars`, {
          items,
        })

        setStopUpdating({ cars: result.data.body })
        callback && callback()
      } catch (e) {
        const message =
          e.response?.data?.message ||
          t('common.error.fetchData', {
            attribute: e.response?.status,
          })

        setStopUpdating(e)

        showSnackbarMessage({
          severity: 'error',
          message,
        })
      }
    },
    [setStartUpdating, setStopUpdating, showSnackbarMessage, t]
  )
  const confirmCars = useCallback(
    async (items, callback) => {
      setStartUpdating()

      try {
        await axios.patch(`${config.apiBaseUrl}logistics/cars/confirm`, {
          items,
        })

        setStopUpdating({ cars: [] })
        callback && callback()
      } catch (e) {
        const message =
          e.response?.data?.message ||
          t('common.error.fetchData', {
            attribute: e.response?.status,
          })

        setStopUpdating(e)

        showSnackbarMessage({
          severity: 'error',
          message,
        })
      }
    },
    [setStartUpdating, setStopUpdating, showSnackbarMessage, t]
  )

  return {
    cars: state.cars,
    isUpdating: state.isUpdating,
    error: state.error,
    updateCheckCars,
    confirmCars,
  }
}

export default useLogistics
